module.exports = __webpack_public_path__ + "img/index-bg-2.71b17543.svg";